<template>
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Региона
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs4>
                <TitleTextField
                  v-model="entity.title"
                  :required="true"
                  :input-language="inputLanguage"
                  :rules="[
                    v => !!v || 'Наименование обязательно к заполнению',
                    v =>
                      v.length >= 3 ||
                      'Наименование должно содержать не менее 3-х символов'
                  ]"
                  label="Наименование*"
                  class="mx-2"
                  @input="entityChange"
                />
              </v-flex>
              <v-flex xs4>
                <TitleTextField
                  v-model="entity.code"
                  :required="true"
                  :input-language="inputLanguage"
                  label="Сокращение"
                  class="mx-2"
                  @input="entityChange"
                />
              </v-flex>
              <v-flex xs4>
                <CountryReference
                  v-model="entity.country"
                  :rules="[v => !!v || '']"
                  :clearable="true"
                  label="Страна*"
                  class="mx-2"
                  @input="entityChange"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-layout v-if="isConfirmed === false">
            <v-btn
              small
              color="primary"
              @click="saveAndClose"
            >
              Подтвердить
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="entity.id!==0 && isConfirmed === false"
              small
              color="error"
              @click="remove(entity.id)"
            >
              Удалить
            </v-btn>
          </v-layout>

          <v-layout v-else>
            <v-btn
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="submit(false)"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="!isModal"
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="saveAndClose"
            >
              Сохранить и закрыть
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="entity.id!==0 || entity.id!==0 && isConfirmed === true"
              small
              :color="entity.isRemoved ? 'success' :'error'"
              @click="changeRemovedState"
            >
              {{ entity.isRemoved ? "Восстановить" : "Удалить" }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import CountryReference from "../countries/CountryReference.vue";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import * as regionsApi from "../../backend/regionsApi.js";

export default {
  components: {
    CountryReference,
  },
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      entity: {
        id: 0,
        title: "",
        code: "",
        country: null,
      },
      entityRestored: false,
      resource: "regions",
      isValid: false,
      isChanged: false,
      loading: false,
    };
  },
  computed: {
    inputLanguage() {
      return this.entity.country ? this.entity.country.inputLanguage : "";
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isConfirmed() {
      if (Object.prototype.hasOwnProperty.call(this.entity, "isConfirmed")) {
        return this.entity.isConfirmed;
      }
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await regionsApi.getRegion(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    entityChange() {
      if (!this.entityRestored && !this.isModal && this.id != 0) {
        return;
      }

      this.isChanged = true;
    },
    async submit(closeAfterSubmit) {
      const entity = {
        id: this.entity.id,
        title: this.entity.title,
        code: this.entity.code,
        countryId: this.entity.country.id,
        isRemoved: this.entity.isRemoved,
        isConfirmed: this.entity.isConfirmed,
      };

      if (this.entity.id && this.entity.id > 0) {
        this.loading = true;
        await regionsApi.updateRegion(this.resource, this.entity.id, entity);
        this.showInfo("Регион изменен");
        this.isChanged = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.loading = false;
      } else {
        this.loading = true;
        const res = await regionsApi.createRegion(this.resource, entity);
        this.showInfo("Регион добавлен");
        this.entity.id = res.data;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
          this.$router.replace(`/${this.resource}/${res.data}`);
        }
        this.loading = false;
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.submit(true);
    },
    async changeRemovedState() {
      await regionsApi.changeRemovedState(this.resource, this.entity);
      this.entity.isRemoved = !this.entity.isRemoved;
    },
    async remove() {
      await regionsApi.deleteRegion(this.resource, this.entity.id);
      this.showInfo("Регион удален");
      this.$router.go(-1);
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
